module.exports = __webpack_public_path__ + "img/strasbourg-logo-icon.47ea59ff.png";